module.exports = __webpack_public_path__ + "static/media/12.023.4176c430.webp";